import { MutationTree } from 'vuex'
import { PronosticoMeteorologicoState, StoreError } from './types'

export const mutations: MutationTree<PronosticoMeteorologicoState> = {
  PRONOSTICO_METEOROLOGICO_FETCHED (state, payload: PronosticoMeteorologicoState) {
    state.error = { state: false }
    state.inicio = payload.inicio
    state.imagenes = payload.imagenes
    state.pasos = payload.pasos
    state.ruta = payload.ruta
    state.fecha_inicio_nieve = payload.fecha_inicio_nieve
    state.centro = payload.centro
    state.latlong = payload.latlong
    state.delta = payload.delta
    state.etiquetas = payload.etiquetas
  },
  PRONOSTICO_METEOROLOGICO_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
